import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { defineMessages, FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import Tag from '@/shared/components/Tag';
import intlShape from '@/shared/utils/intlShape';
import HasFeature from '@/shared/components/security/HasFeature';
import AuthService from '@/shared/services/AuthService';

const messages = defineMessages({
  Relation: 'Relation',
  Assignment: 'Assignment',
  ResourceType: 'ResourceType',
  ResourceCategory: 'ResourceCategory',
  ResourceSubcategory: 'ResourceSubcategory',
  TaskTemplate: 'Task template',
  SubtaskTemplate: 'Subtask template',
  PlannedTask: 'Planned task',
  PlannedSubtask: 'Planned subtask',
  User: 'User',
  Year: 'Year',
  Month: 'Month',
  Date: 'Date',
  ReferenceYear: 'Reference year',
  OwnCompany: 'Own company',
  Details: 'Details',
  GroupBy: 'GroupBy',
  RemoveGroup: 'RemoveGroup',
  AddGroup: 'AddGroup',
});

class GroupByFilter extends PureComponent {
  constructor(props) {
    super(props);
    const { intl } = props;
    const groups = [
      { id: 1, name: intl.formatMessage(messages.Relation) },
      { id: 2, name: intl.formatMessage(messages.Assignment) },
      { id: 3, name: intl.formatMessage(messages.ResourceType) },
      { id: 4, name: intl.formatMessage(messages.ResourceCategory) },
      { id: 5, name: intl.formatMessage(messages.ResourceSubcategory) },
      { id: 6, name: intl.formatMessage(messages.TaskTemplate) },
      { id: 8, name: intl.formatMessage(messages.User) },
      { id: 9, name: intl.formatMessage(messages.Year) },
      { id: 10, name: intl.formatMessage(messages.Month) },
      { id: 11, name: intl.formatMessage(messages.Date) },
      { id: 13, name: intl.formatMessage(messages.OwnCompany) },
      { id: 15, name: intl.formatMessage(messages.SubtaskTemplate) },
      { id: 99, name: intl.formatMessage(messages.Details) },
    ];
    if (AuthService.hasFeature('ReferenceYear'))
      groups.push({ id: 12, name: intl.formatMessage(messages.ReferenceYear) });

    this.state = {
      groups: groups.sort(dynamicSort('name')),
    };
  }

  removeGroup(item) {
    const { value, onChange } = this.props;

    const newValue = value.filter(x => x !== item.id);
    onChange(newValue);
  }

  addGroup(item) {
    if (!item) return;
    const { value = [], onChange } = this.props;
    if (value.indexOf(item.id) >= 0) return; // Already in list
    if (value.length === 0) {
      onChange([item.id]);
      return;
    }

    const detailsIdx = value.indexOf(99);
    if (detailsIdx < 0) {
      onChange([...value, item.id]);
      return;
    }
    // Has details
    const newValue = [
      ...value.slice(0, detailsIdx),
      ...value.slice(detailsIdx + 1),
      item.id,
      ...value.slice(detailsIdx, detailsIdx + 1),
    ];
    onChange(newValue);
  }

  render() {
    const { groups } = this.state;
    const { value, hidden = [], intl } = this.props;

    const visibleGroups =
      !hidden || !hidden.length ? groups : groups.filter(l => hidden.indexOf(l.id) < 0);
    const selectedGroups =
      !value || !value.length
        ? []
        : value.map(x => visibleGroups.find(l => l.id === x)).filter(l => l && l.id);

    const availableGroups =
      !value || !value.length ? visibleGroups : visibleGroups.filter(l => value.indexOf(l.id) < 0);

    const removeGroupTitle = intl.formatMessage(messages.RemoveGroup);

    return (
      <div>
        {/* <label className="margin5R">
          <FormattedMessage {...messages.GroupBy} />
        </label> */}
        {availableGroups && availableGroups.length > 0 ? (
          // <div
          //   className={classnames('dropdown inline-block', {
          //     'pull-right': selectedGroups && selectedGroups.length > 0,
          //   })}
          // >
          <div className="dropdown inline-block margin10R">
            <button
              className="btn btn-default"
              type="button"
              id="RegistrationPerGroupFilterDropDown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <FormattedMessage {...messages.AddGroup} /> <span className="caret margin5L" />
            </button>
            <ul className="dropdown-menu" aria-labelledby="RegistrationPerGroupFilterDropDown">
              {availableGroups.map(l => (
                <li key={l.id}>
                  <a onClick={() => this.addGroup(l)}>{l.name}</a>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        <label className="margin5R">
          <FormattedMessage {...messages.GroupBy} />
        </label>
        {selectedGroups && selectedGroups.length > 0
          ? selectedGroups.map(l => (
              <Tag
                removeTitle={removeGroupTitle}
                key={l.id}
                item={{ ...l, value: {} }}
                onRemove={item => this.removeGroup(item)}
              />
            ))
          : null}
      </div>
    );
  }
}

GroupByFilter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
  hidden: PropTypes.arrayOf(PropTypes.number),
};
GroupByFilter.defaultProps = {
  hidden: [],
};
export default injectIntl(GroupByFilter);
